<div class="flex flex-col gap-form-field" data-testid="advanced-search-panel">
    <interacta-form-field
        data-testid="advanced-search-some"
        [control]="formGroup().controls.some"
        [name]="'SEARCH.SOME_WORD' | translate"
    >
        <interacta-input-text
            [control]="formGroup().controls.some"
            [focusOnInit]="true"
            (keyup.enter)="doSearch()"
        />
    </interacta-form-field>
    <interacta-form-field
        data-testid="advanced-search-exactly"
        [control]="formGroup().controls.exactly"
        [name]="'SEARCH.STRING_EXACTLY' | translate"
    >
        <interacta-input-text
            [control]="formGroup().controls.exactly"
            (keyup.enter)="doSearch()"
        />
    </interacta-form-field>
    <interacta-form-field
        data-testid="advanced-search-every"
        [control]="formGroup().controls.every"
        [name]="'SEARCH.EVERY_WORD' | translate"
    >
        <interacta-input-text
            [control]="formGroup().controls.every"
            (keyup.enter)="doSearch()"
        />
    </interacta-form-field>
    <interacta-form-field
        data-testid="advanced-search-none"
        [control]="formGroup().controls.none"
        [name]="'SEARCH.NONE_WORD' | translate"
    >
        <interacta-input-text
            [control]="formGroup().controls.none"
            (keyup.enter)="doSearch()"
        />
    </interacta-form-field>
    <div class="flex justify-between">
        <button
            data-testid="advanced-search-standard-button"
            interacta-button
            type="button"
            [label]="'SEARCH.STANDARD' | translate"
            [size]="'small'"
            [style]="'text-primary'"
            (click)="closePanel.emit()"
        ></button>
        <button
            data-testid="advanced-search-submit"
            interacta-button
            type="button"
            [label]="'UI.BUTTON.SEARCH' | translate"
            [size]="'small'"
            [style]="'filled'"
            (click)="doSearch()"
        ></button>
    </div>
</div>
